module.exports = __webpack_public_path__ + "static/media/tick.961591df.svg";